import { getMinutes, addDays, addMinutes } from "date-fns"

export const formatInitialDate = (date: Date) => {
  const minutes = getMinutes(date)

  if (minutes === 0) {
    return date
  }

  return addDays(addMinutes(date, 60 - minutes), 1)
}
